export const storageKeyLoginRedirect = 'login-redirect';
export const storageKeyVerifyPasswordCancel = 'verify-password-cancel';
export const storageKeyVerifyPasswordRedirect = 'verify-password-redirect';
